import { AUTO_HEIGHT_COMP_TYPES, Component } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../cssCompNode'
import { envRefs } from '@wix/thunderbolt-catharsis'
import { StylableHorizontalMenuProps } from '@wix/thunderbolt-components-native'
import { AutoHeightWrapperSymbol } from './symbols'
import type { FeatureRefs } from '../cssFeatures.types'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'

export const autoHeightWrapper = createCssCompNode('pinnedLayout', 'autoHeightWrapper', {
	getDependencies: (component: Component, refs: FeatureRefs<'pinnedLayout'>) => {
		return {
			metaSiteId: envRefs.metaSiteId,
			compProps:
				component.componentType === 'StylableHorizontalMenu'
					? refs.propertyQuery<StylableHorizontalMenuProps>(component.propertyQuery!)
					: null,
			experiments: envRefs.experiments,
		}
	},
	toViewItem: (component: Component, deps): boolean => {
		if (
			deps &&
			deps.metaSiteId && //  only regular sites (no mini sites with auto height wrapper)
			(AUTO_HEIGHT_COMP_TYPES[component.componentType] ||
				(component.componentType === 'StylableHorizontalMenu' && deps.compProps?.menuMode === 'wrap')) // Add StylableHorizontalMenu to auto height wrapper only if it's in wrap mode
		) {
			return true
		}
		return false
	},
})

export const autoHeightWrapperViewer = createCssCompNode('pinnedLayout', 'autoHeightWrapper', {
	getDependencies: () => null,
	toViewItem: (): boolean => false,
})

export const page: BindFeature = (bind) => {
	bind(AutoHeightWrapperSymbol).toConstantValue(autoHeightWrapperViewer)
}

export const editor: BindFeature = (bind) => {
	bind(AutoHeightWrapperSymbol).toConstantValue(autoHeightWrapper)
}
